import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './userOrder.css';

function UserOrders() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);

  const getOrdersByPhone = async (phoneNumber) => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/orders/get-orders-by-phone?phone=${phoneNumber}`);
      if (response.ok) {
        const data = await response.json();
        setOrders(data.orders);
      } else {
        setError('No orders found for this phone number');
        setOrders([]);
      }
    } catch (err) {
      setError('An error occurred while fetching orders');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    navigate("/login");
  };

  useEffect(() => {
    const phone = JSON.parse(localStorage.getItem("userDetails"))?.phone;
    if (phone) {
      setPhone(phone);
      getOrdersByPhone(phone);
    }
  }, []);

  const openModal = (order) => {
    setSelectedOrder(order);
    setFeedback('');
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const handleFeedbackSubmit = async () => {
    if (!feedback.trim()) return;

    const feedbackData = {
      name: selectedOrder.userName,
      phone: selectedOrder.phone,
      feedback: feedback.trim()
    };

    try {
      const response = await fetch('https://swarna-herbal-backend.onrender.com/api/feedback/add-feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
      });

      if (response.ok) {
        alert('Thank you for your feedback!');
        closeModal();
      } else {
        alert('Failed to submit feedback.');
      }
    } catch (err) {
      alert('An error occurred.');
    }
  };

  const formateDate = (createdAt) => {
    if(createdAt){
 const date = new Date(createdAt);
    return date.toLocaleDateString();
    }else{
      return "-";
    }
   
  };

  return (
    <div className="user-orders-container">
      {!phone && (
        <div className="search-container">
          <h2>Login To Get Your Order Details</h2>
          <form onSubmit={handleSubmit} className="search-form">
            <button type="submit" className="search-button">Login</button>
          </form>
        </div>
      )}

      {loading && <p className="error-message">Loading your orders...</p>}
      {error && <p className="error-message">{error}</p>}

      {orders.length > 0 && !loading && (
        <div className="orders-list">
          <h3>Your Orders</h3>
          <table className="orders-table">
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Phone</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Price (₹)</th>
                <th>Delivery Address</th>
                <th>Order Date</th>
                <th>Estimated Delivery Date</th>
                <th>Payment Status</th>
                <th>Delivery Status</th>
                <th>Feedback</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => {
                const address = `${order.landmark}, ${order.city}, ${order.state} - ${order.pinCode}`;
                return (
                  <tr key={index}>
                    <td>{order.userName}</td>
                    <td>{order.phone}</td>
                    <td>{order.itemName}</td>
                    <td>{order.quantity}</td>
                    <td>{order.price}</td>
                    <td>{address}</td>
                    <td>{formateDate(order.createdAt)}</td>
                    <td>{formateDate(order.estimatedDeliveryDate)}</td>
                    <td className={`status ${order.paymentStatus}`}>{order.paymentStatus}</td>
                    <td className={`status ${order.deliveryStatus}`}>{order.deliveryStatus}</td>
                    <td>
                      {order.deliveryStatus === 'Delivered' && (
                        <button onClick={() => openModal(order)}>Give Feedback</button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Feedback Modal */}
      {showModal && selectedOrder && (
        <div className="feedback-modal">
          <div className="modal-content">
            <h3>Feedback for {selectedOrder.itemName}</h3>
            <p><strong>Name:</strong> {selectedOrder.userName}</p>
            <p><strong>Phone:</strong> {selectedOrder.phone}</p>
            <textarea
              placeholder="Write your feedback here..."
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
            <button onClick={handleFeedbackSubmit}>Submit Feedback</button>
            <button onClick={closeModal}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserOrders;
